export class Word {
  constructor ({name, body, isImmediate = false}) {
    this.name = name
    this.body = body
    this.isImmediate = isImmediate
  }
}

function nop() {
}

export class ForthVM {
  constructor () {
    this.stack = []
    this.controlStack = []
    this.pc = 0
    this.compiledWordArray = []
    this.dictionary = {
      'dup': new Word({
        name: 'dup',
        body: () => {
          // n - n n
          let n = this.pop()
          this.push(n)
          this.push(n)
        }
      }),
      'swap': new Word({
        name: 'swap',
        body: () => {
          // b a - a b
          let a = this.pop()
          let b = this.pop()
          this.push(a)
          this.push(b)
        }
      }),
      'over': new Word({
        name: 'over',
        body: () => {
          // n m - n m n
          let m = this.pop()
          let n = this.pop()
          this.push(n)
          this.push(m)
          this.push(n)
        }
      }),
      '+': new Word({
        name: '+',
        body: () => {
          // b a - (a+b)
          let a = this.pop()
          let b = this.pop()
          this.push(a+b)
        }
      }),
      '-': new Word({
        name: '-',
        body: () => {
          // b a - (b-a)
          let a = this.pop()
          let b = this.pop()
          this.push(b-a)
        }
      }),
      '*': new Word({
        name: '*',
        body: () => {
          // b a - (a*b)
          let a = this.pop()
          let b = this.pop()
          this.push(a*b)
        }
      }),
      '/': new Word({
        name: '/',
        body: () => {
          // b a - (b/a)
          let a = this.pop()
          let b = this.pop()
          this.push(Math.floor(b/a))
        }
      }),
      'mod': new Word({
        name: 'mod',
        body: () => {
          // b a - (b%a)
          let a = this.pop()
          let b = this.pop()
          this.push(b%a)
        }
      }),
      '=': new Word({
        name: '=',
        body: () => {
          // b a - f
          let a = this.pop()
          let b = this.pop()
          if (a === b) {
            this.push(1)
          } else {
            this.push(0)
          }
        }
      }),
      '!=': new Word({
        name: '!=',
        body: () => {
          // b a - f
          let a = this.pop()
          let b = this.pop()
          if (a !== b) {
            this.push(1)
          } else {
            this.push(0)
          }
        }
      }),
      '<': new Word({
        name: '<',
        body: () => {
          // b a - (b<a)
          let a = this.pop()
          let b = this.pop()
          if (b < a) {
            this.push(1)
          } else {
            this.push(0)
          }
        }
      }),
      '>': new Word({
        name: '>',
        body: () => {
          // b a - (b>a)
          let a = this.pop()
          let b = this.pop()
          if (b > a) {
            this.push(1)
          } else {
            this.push(0)
          }
        }
      }),
      'and': new Word({
        name: 'and',
        body: () => {
          // b a - (a&&b)
          let a = this.pop()
          let b = this.pop()
          if (ForthVM.isTrue(a) && ForthVM.isTrue(b)) {
            this.push(1)
          } else {
            this.push(0)
          }
        }
      }),
      'or': new Word({
        name: 'or',
        body: () => {
          // b a - (a&&b)
          let a = this.pop()
          let b = this.pop()
          if (ForthVM.isTrue(a) || ForthVM.isTrue(b)) {
            this.push(1)
          } else {
            this.push(0)
          }
        }
      }),
      'sum': new Word({
        name: 'sum',
        body: () => {
          // ... n - m
          this.stack = [this.stack.reduce((v, a) => v+a, 0)]
        }
      }),
      'if': new Word({
        name: 'if',
        body: () => {
          let resolverAddress = this.pc
          // This place holder
          // will be replaced by 'else' or 'then'
          this.compiledWordArray.push(() => {
            console.log('I am if-resolver')
            throw new Error(`unbalanced 'if-then' structure`)
          })
          // Forward reference origin will be
          // resolved by 'else' or 'then'
          this.controlStack.push((destination) => {
            // Replace place holder
            this.compiledWordArray[resolverAddress] = () => {
              // x -
              let x = this.pop()
              if (ForthVM.isTrue(x)) {
                // NOP
              } else {
                this.pc = destination
              }
            }
          })
        },
        isImmediate: true
      }),
      'else': new Word({
        name: 'else',
        body: () => {
          // Resolve 'if' branch.
          let ifResolver = this.controlStack.pop()
          if (!ifResolver) {
            throw new Error(`unbalanced 'if-then' structure`)
          }
          ifResolver(this.pc)

          // push own resolver to control stack.
          let resolverAddress = this.pc
          this.compiledWordArray.push(() => {
            console.log('I am else-resolver')
            throw new Error(`unbalanced 'if-else-then' structure`)
          })
          // will be resolved by 'then'
          this.controlStack.push((destination) => {
            this.compiledWordArray[resolverAddress] = () => {
              // undonditional branch from end of true clause to 'then'
              this.pc = destination
            }
          })

        },
        isImmediate: true
      }),
      'then': new Word({
        name: 'then',
        body: () => {
          let resolver = this.controlStack.pop()
          if (!resolver) {
            throw new Error(`unbalanced 'if-then' structure`)
          }
          resolver(this.pc)
          this.compiledWordArray.push(nop)
        },
        isImmediate: true
      })
    }
  }

  static isTrue (n) {
    return n != 0
  }

  push (elem) {
    this.stack.push(elem)
  }

  pop () {
    let val = this.stack.pop()
    return val ? val : 0
  }

  tos () {
    return this.stack[this.stack.length-1]
  }

  compileNumber (n) {
    this.compiledWordArray.push(
      () => { this.push(n) }
    )
  }

  compile (wordArray) {
    this.pc = 0
    this.compiledWordArray = []
    for (; this.pc < wordArray.length; this.pc++) {
      let w = wordArray[this.pc]
      let word = this.dictionary[w]
      if (word) {
        if (word.isImmediate) {
          word.body()
        } else {
          this.compiledWordArray.push(word.body)
        }
      } else {
        let num = parseInt(w)
        if (isNaN(num)) {
          throw new Error(`undefined word: ${w}`)
        } else {
          this.compileNumber(num)
        }
      }
    }
    return () => {
      this.controlStack.push(this.pc)
      this.pc = 0
      // allocate memory for new word.
      let compiledWordArray = this.compiledWordArray.slice(0)
      for (; this.pc < compiledWordArray.length; this.pc++) {
        compiledWordArray[this.pc]()
      }
      this.pc = this.controlStack.pop()
    }
  }

  clear () {
    this.pc = 0
    this.stack = []
  }
}
